import type { ReactNode } from 'react'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgNoBillingMethodsV2Url from '@/assets/misc/img_no-billing-methods-v2.svg'
import NoBillingMethodsIllustration from '@/components/SpotIllustration/NoBillingMethodsIllustration'

interface BillingEmptyStateProps {
  title: string
  subtitle: string
  children?: ReactNode
  corporateMode: boolean
}

export function BillingEmptyState({
  title,
  subtitle,
  children,
  corporateMode,
}: BillingEmptyStateProps) {
  return (
    <EmptyState grow>
      {!corporateMode && (
        <EmptyStateIllustration
          src={imgNoBillingMethodsV2Url}
          illustration={byDesign(undefined, NoBillingMethodsIllustration)}
          alt="Illustration of a man reading a large invoice"
        />
      )}
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateDescription>{subtitle}</EmptyStateDescription>
      {children && <EmptyStateActions>{children}</EmptyStateActions>}
    </EmptyState>
  )
}
